import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class locationForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="partner"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Partner"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <ComponentField
                        getFieldProps={this.props.getFieldProps}
                        componentConfig={this.props.componentConfig}
                        name="address"
                        values={this.props.values}
                        setFieldValue={this.props.setFieldValue}
                        label="Cím"
                    />
                </div>
            </form>
        );
    }
}

export default createForm(locationForm);
